import React from 'react';
import { useParams } from 'react-router-dom';
import PageContent from '../../../components/Main/Content/mainContent';
import SaleSearch from '../../../components/Sale/Search/saleSearch';

const VendaPesquisa = () => {
  const { id } = useParams();

  return (
    <PageContent>
      <SaleSearch referenceId={id ? Number.parseInt(id, 10) : null} />
    </PageContent>
  );
};

export default VendaPesquisa;
